var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mastercard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.441,
    height: 38.668,
    viewBox: "0 0 66.441 38.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M21.681,34.05a19.481,19.481,0,0,0,0-29.431A18.908,18.908,0,0,1,34.079,0,19.224,19.224,0,0,1,53.191,19.334,19.224,19.224,0,0,1,34.079,38.668,18.909,18.909,0,0,1,21.681,34.05Z",
    transform: "translate(13.251)",
    fill: "#c9c9c9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M31.509,34.05a19.481,19.481,0,0,1,0-29.431A18.908,18.908,0,0,0,19.112,0,19.224,19.224,0,0,0,0,19.334,19.224,19.224,0,0,0,19.112,38.668,18.909,18.909,0,0,0,31.509,34.05Z",
    transform: "translate(0)",
    fill: "#c9c9c9",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M23.14,32.387a19.481,19.481,0,0,0,0-29.431,19.481,19.481,0,0,0,0,29.431Z",
    transform: "translate(10.039 1.807)",
    fill: "#c9c9c9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.6fec94723f1cdab033c29a84a396f5e5.svg";
export { ForwardRef as ReactComponent };